export const SEEK_STATUS = {
  PROCESSING: "PROCESSING",
  COMPLETED: "COMPLETED",
  ERROR: "ERROR",
  REQUESTED: "REQUESTED"
} 

export const SEEK_IN_PROGRESS = [SEEK_STATUS.PROCESSING, SEEK_STATUS.REQUESTED];